module.exports = __webpack_public_path__ + "static/img/bg6.43bbde9a.png";